export default __webpack_public_path__ + "static/media/chevron-left.aa7c8da9.svg";